export default starRating => {
    if ($('.star-ratings').length < 1) {
        return false;
    }

    let $starRatings = $('.star-ratings');

    $starRatings.each((key, rating) => {
        let $rating = $(rating);
        let value = parseInt($rating.data('rating'));

        if ($rating.hasClass('initialized')) {
            return;
        }

        // set the width of the stars
        $rating.find('.star-ratings-top').width(value+'%');

        return $rating.addClass('initialized');
    });
};